import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'

  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("@/components/login/Login.vue")
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import("@/components/home/Home.vue"),
    redirect: '/home/homeTop',
    // 二级路由
    children: [
      {
        path: 'homeTop',
        name: 'HomeTop',
        component: () => import("@/components/home/homeSlid/HomeTop.vue")
      },
      {
        path: '/alert',
        name: 'Alert',
        component: () => import("@/components/news/Alert.vue")
      },
      {
        path: '/producs',
        name: 'ProDucs',
        component: () => import("@/components/producs/ProDucs.vue")
      },
      {
        path: '/mine',
        name: 'Mine',
        component: () => import("@/components/mine/Mine.vue")
      }
    ]
  },
  {
    path: '/user',
    name: 'User',
    component: () => import("@/components/mine/User.vue")
  },
  {
    path: '/tencent',
    name: 'Tencent',
    component: () => import("@/components/home/Tencent/Tencent.vue")
  },
  {
    path: '/tencentInfo',
    name: 'TencentInfo',
    component: () => import("@/components/home/Tencent/TencentInfo.vue")
  },
  {
    path: '/add',
    name: 'Add',
    component: () => import("@/components/openter/Add.vue"),
  },
  {
    path: '/addInfo',
    name: 'AddInfo',
    component: () => import("@/components/openter/AddInfo.vue"),
  },
  {
    path: '/device',
    name: 'Device',
    component: () => import("@/components/openter/Device.vue")
  },
  {
    path: '/unknown',
    name: 'Unknown',
    component: () => import("@/components/openter/Unknown.vue")
  },
  {
    path: '/ashebei',
    name: 'Ashebei',
    component: () => import("@/components/openter/Ashebei/Ashebei.vue")
  },
  {
    path: '/ashebeiInfo',
    name: 'AshebeiInfo',
    component: () => import("@/components/openter/Ashebei/AshebeiInfo.vue")
  },
  {
    path: '/hair',
    name: 'Hair',
    component: () => import('@/components/home/binding/hair.vue'),
  },
  {
    path: '/menuber',
    name: 'Menuber',
    component: () => import("@/components/openter/Menuber.vue")
  },
  {
    path: '/menuberInfo',
    name: 'MenuberInfo',
    component: () => import("@/components/openter/MenuberInfo.vue")
  },
  {
    path: '/binding',
    name: 'Binding',
    component: () => import('@/components/home/binding/Binding.vue')
  },
  {
    path: '/bindingInfo',
    name: 'BindingInfo',
    component: () => import('@/components/home/binding/BindingInfo.vue')
  },
  {
    path: '/profiler',
    name: 'Profiler',
    component: () => import('@/components/home/binding/profiler/Profiler.vue')
  },
  {
    path: '/shopping',
    name: 'Shopping',
    component: () => import('@/components/home/binding/Shopping.vue')
  },
  {
    path: '/shoppingInfo',
    name: 'ShoppingInfo',
    component: () => import('@/components/home/binding/shopInfo.vue')
  },
  {
    path: '/deviceqwe',
    name: 'Deviceqwe',
    component: () => import('@/components/home/binding/Deviceqwe.vue')
  },
  {
    path: '/deviceqweInfo',
    name: 'DeviceqweInfo',
    component: () => import('@/components/home/binding/DeviceqweInfo.vue')
  },
  {
    path: '/bution',
    name: 'Bution',
    component: () => import('@/components/home/distribution/Bution.vue')
  },
  {
    path: '/butioninfo',
    name: 'Butioninfo',
    component: () => import('@/components/home/distribution/Butioninfo.vue')
  },
  {
    path: '/brand',
    name: 'Brand',
    component: () => import('@/components/home/brand/Brand.vue')
  },
  {
    path: '/feed',
    name: 'Feed',
    component: () => import('@/components/home/feed/Feed.vue')
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import('@/components/home/feedback/Feedback.vue')
  },
  {
    path: '/marketing',
    name: 'Marketing',
    component: () => import('@/components/home/marketing/Marketing.vue')
  },
  {
    path: '/system',
    name: 'System',
    component: () => import('@/components/producs/system/System.vue')
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('@/components/news/Report/report.vue')
  },
  {
    path: '/wance',
    name: 'Wance',
    component: () => import('@/components/home/wance/wance.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 开启路由守卫
router.beforeEach((to, from, next) => {
  // 取token值
  let token = window.localStorage.getItem('token');

  if (to.path == '/login') {
    next();
  } else {
    // 如果有token 放行 没有就去login页面登录 
    if (token) {
      next();
    } else {
      next("/login")
    }
  }
})

//  
//                                  _oo8oo_
//                                 o8888888o
//                                 88" . "88
//                                 (| -_- |)
//                                 0\  =  /0
//                               ___/'==='\___
//                             .' \\|     |// '.
//                            / \\|||  :  |||// \
//                           / _||||| -:- |||||_ \
//                          |   | \\\  -  /// |   |
//                          | \_|  ''\---/''  |_/ |
//                          \  .-\__  '-'  __/-.  /
//                        ___'. .'  /--.--\  '. .'___
//                     ."" '<  '.___\_<|>_/___.'  >' "".
//                    | | :  `- \`.:`\ _ /`:.`/ -`  : | |
//                    \  \ `-.   \_ __\ /__ _/   .-` /  /
//                =====`-.____`.___ \_____/ ___.`____.-`=====
//                                  `=---=`
//  
//  
//               ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// 
//                          佛祖保佑         永不宕机/永无bug
//


export default router